import { apiGet } from '../api'

export const forgot_password = email => {
  return apiGet({
    endpoint: `user/recover?user_email=${email}`
  })
}
